"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.erythropoetinProductActiveIngredientMessages = exports.vitaminDactiveIngredientMessages = exports.calciumActiveIngredientMessages = exports.drugTypeMessages = exports.ErythropoetinProductActiveIngredient = exports.VitaminDactiveIngredient = exports.CalciumActiveIngredient = exports.DrugType = void 0;
const schema_1 = require("../../../../schema");
var DrugType;
(function (DrugType) {
    DrugType["DRUG_TYPE_ACEI"] = "drug_type_acei";
    DrugType["DRUG_TYPE_ARB"] = "drug_type_arb";
    DrugType["DRUG_TYPE_BETA_RECEPTOR_INHIBITOR"] = "drug_type_beta_receptor inhibitor";
    DrugType["DRUG_TYPE_DIURETICS"] = "drug_type_diuretics";
    DrugType["DRUG_TYPE_AMLODIPINE_DHP"] = "drug_type_amlodipine_dhp";
    DrugType["DRUG_TYPE_NON_DHP"] = "drug_type_nonDHP";
    DrugType["DRUG_TYPE_AMIODARONE"] = "drug_type_amiodarone";
    DrugType["DRUG_TYPE_ACETHYLSALICILATE"] = "drug_type_acethylsalicilate";
    DrugType["DRUG_TYPE_CLOPIDOGREL"] = "drug_type_clopidogrel";
    DrugType["DRUG_TYPE_OTHER_TAGS_THROMBOCYTE_AGGREGATION_INHIBITORS"] = "drug_type_other_TAGs_thrombocyte_aggregation_inhibitors";
    DrugType["DRUG_TYPE_CALCIUM_CONTAIN_PHOSPPHATE_BINDERS"] = "drug_type_calcium_contain_phospphate_binders";
    DrugType["DRUG_TYPE_VITAMINE_D_PRODUCT"] = "drug_type_vitamine_D_product";
    DrugType["DRUG_TYPE_ERYTHROPOETIN_PRODUCT"] = "drug_type_erythropoetin_product";
    DrugType["DRUG_TYPE_OAC_NOAC"] = "drug_type_OAC_NOAC";
    DrugType["DRUG_TYPE_OTHER"] = "drug_type_other";
})(DrugType || (exports.DrugType = DrugType = {}));
var CalciumActiveIngredient;
(function (CalciumActiveIngredient) {
    CalciumActiveIngredient["CALCICARB"] = "calcicarb";
    CalciumActiveIngredient["CALCETAT"] = "calcetat";
    CalciumActiveIngredient["PHOSPHODEP"] = "phosphodep";
    CalciumActiveIngredient["RENVELA"] = "renvela";
    CalciumActiveIngredient["IRON_CONTAINING_PHOSPHATE_BINDER"] = "iron_containing_phosphate_binder";
})(CalciumActiveIngredient || (exports.CalciumActiveIngredient = CalciumActiveIngredient = {}));
var VitaminDactiveIngredient;
(function (VitaminDactiveIngredient) {
    VitaminDactiveIngredient["OH_CHOLECALCIFEROL"] = "oh_cholecalciferol";
    VitaminDactiveIngredient["ALFACALCIDIOL"] = "alfacalcidiol";
    VitaminDactiveIngredient["CALCITRIOL"] = "calcitriol";
    VitaminDactiveIngredient["MIMPARA"] = "mimpara";
    VitaminDactiveIngredient["ZEMPLAR"] = "zemplar";
    VitaminDactiveIngredient["OTHER"] = "other";
})(VitaminDactiveIngredient || (exports.VitaminDactiveIngredient = VitaminDactiveIngredient = {}));
var ErythropoetinProductActiveIngredient;
(function (ErythropoetinProductActiveIngredient) {
    ErythropoetinProductActiveIngredient["DARBAPOETIN"] = "darbapoetin";
    ErythropoetinProductActiveIngredient["EPOETIN_BETA"] = "epoetin_beta";
    ErythropoetinProductActiveIngredient["ARANESP"] = "aranesp";
    ErythropoetinProductActiveIngredient["BINOCRIT"] = "binocrit";
    ErythropoetinProductActiveIngredient["NEO_RECORMON"] = "neo_recormon";
    ErythropoetinProductActiveIngredient["EPORATIO"] = "eporatio";
    ErythropoetinProductActiveIngredient["RETACRIT"] = "retacrit";
    ErythropoetinProductActiveIngredient["METHOXY_POLYETHYLENEGLYCOL_EPOETIN_BETA"] = "methoxy_polyethyleneglycol_epoetin_beta";
    ErythropoetinProductActiveIngredient["OTHER"] = "other";
})(ErythropoetinProductActiveIngredient || (exports.ErythropoetinProductActiveIngredient = ErythropoetinProductActiveIngredient = {}));
exports.drugTypeMessages = {
    [DrugType.DRUG_TYPE_ACEI]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_ACEI",
        defaultMessage: "ACEI"
    },
    [DrugType.DRUG_TYPE_ARB]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_ARB",
        defaultMessage: "ARB"
    },
    [DrugType.DRUG_TYPE_BETA_RECEPTOR_INHIBITOR]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_BETA_RECEPTOR_INHIBITOR",
        defaultMessage: "ß blokkoló"
    },
    [DrugType.DRUG_TYPE_DIURETICS]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_DIURETICS",
        defaultMessage: "Diuretikum"
    },
    [DrugType.DRUG_TYPE_AMLODIPINE_DHP]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_AMLODIPINE_DHP",
        defaultMessage: "Amlodipine - DHP"
    },
    [DrugType.DRUG_TYPE_NON_DHP]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_NON_DHP",
        defaultMessage: "Verapamil diltiazem"
    },
    [DrugType.DRUG_TYPE_AMIODARONE]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_AMIODARONE",
        defaultMessage: "Amiodarone"
    },
    [DrugType.DRUG_TYPE_ACETHYLSALICILATE]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_ACETHYLSALICILATE",
        defaultMessage: "Acethylsalicilate"
    },
    [DrugType.DRUG_TYPE_CLOPIDOGREL]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_CLOPIDOGREL",
        defaultMessage: "Clopidogrel"
    },
    [DrugType.DRUG_TYPE_OTHER_TAGS_THROMBOCYTE_AGGREGATION_INHIBITORS]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_OTHER_TAGS_THROMBOCYTE_AGGREGATION_INHIBITORS",
        defaultMessage: "Egyéb TAG"
    },
    [DrugType.DRUG_TYPE_CALCIUM_CONTAIN_PHOSPPHATE_BINDERS]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_CALCIUM_CONTAIN_PHOSPPHATE_BINDERS",
        defaultMessage: "Calcium tartalmú P kötő"
    },
    [DrugType.DRUG_TYPE_VITAMINE_D_PRODUCT]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_VITAMINE_D_PRODUCT",
        defaultMessage: "D vitamin anyagcserére ható készítmények"
    },
    [DrugType.DRUG_TYPE_ERYTHROPOETIN_PRODUCT]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_ERYTHROPOETIN_PRODUCT",
        defaultMessage: "Erythropoietin készítmény"
    },
    [DrugType.DRUG_TYPE_OAC_NOAC]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_OAC_NOAC",
        defaultMessage: "OAC/NOAC (orális antikoagulánsok / új orális antikoagulánsok)"
    },
    [DrugType.DRUG_TYPE_OTHER]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.drugType.DRUG_TYPE_OTHER",
        defaultMessage: "Egyéb gyógyszer csoport"
    }
};
exports.calciumActiveIngredientMessages = {
    [CalciumActiveIngredient.CALCICARB]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.calciumActiveIngredient.CALCICARB",
        defaultMessage: "Calcicarb"
    },
    [CalciumActiveIngredient.CALCETAT]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.calciumActiveIngredient.CALCETAT",
        defaultMessage: "Calcetat"
    },
    [CalciumActiveIngredient.PHOSPHODEP]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.calciumActiveIngredient.PHOSPHODEP",
        defaultMessage: "Phosphodep"
    },
    [CalciumActiveIngredient.RENVELA]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.calciumActiveIngredient.RENVELA",
        defaultMessage: "Sevelamer"
    },
    [CalciumActiveIngredient.IRON_CONTAINING_PHOSPHATE_BINDER]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.calciumActiveIngredient.IRON_CONTAINING_PHOSPHATE_BINDER",
        defaultMessage: "Vastartalmú P kötő"
    }
};
exports.vitaminDactiveIngredientMessages = {
    [VitaminDactiveIngredient.OH_CHOLECALCIFEROL]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.vitaminDactiveIngredient.OH_CHOLECALCIFEROL",
        defaultMessage: "1,25OH Cholecalciferol"
    },
    [VitaminDactiveIngredient.ALFACALCIDIOL]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.vitaminDactiveIngredient.ALFACALCIDIOL",
        defaultMessage: "Alfacalcidiol"
    },
    [VitaminDactiveIngredient.CALCITRIOL]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.vitaminDactiveIngredient.CALCITRIOL",
        defaultMessage: "Calcitriol"
    },
    [VitaminDactiveIngredient.MIMPARA]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.vitaminDactiveIngredient.MIMPARA",
        defaultMessage: "Cinacalcet"
    },
    [VitaminDactiveIngredient.ZEMPLAR]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.vitaminDactiveIngredient.ZEMPLAR",
        defaultMessage: "Paricalcitol"
    },
    [VitaminDactiveIngredient.OTHER]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.vitaminDactiveIngredient.OTHER",
        defaultMessage: "Egyéb"
    }
};
exports.erythropoetinProductActiveIngredientMessages = {
    [ErythropoetinProductActiveIngredient.DARBAPOETIN]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.erythropoetinProductActiveIngredient.DARBAPOETIN",
        defaultMessage: "Darbapoetin"
    },
    [ErythropoetinProductActiveIngredient.EPOETIN_BETA]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.erythropoetinProductActiveIngredient.EPOETIN_BETA",
        defaultMessage: "Epoetin Beta"
    },
    [ErythropoetinProductActiveIngredient.ARANESP]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.erythropoetinProductActiveIngredient.ARANESP",
        defaultMessage: "Darbapoetin alfa"
    },
    [ErythropoetinProductActiveIngredient.BINOCRIT]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.erythropoetinProductActiveIngredient.BINOCRIT",
        defaultMessage: "Epoetin Alfa"
    },
    [ErythropoetinProductActiveIngredient.NEO_RECORMON]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.erythropoetinProductActiveIngredient.NEO_RECORMON",
        defaultMessage: "Epoetin Beta"
    },
    [ErythropoetinProductActiveIngredient.EPORATIO]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.erythropoetinProductActiveIngredient.EPORATIO",
        defaultMessage: "Epoetin Teta"
    },
    [ErythropoetinProductActiveIngredient.RETACRIT]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.erythropoetinProductActiveIngredient.RETACRIT",
        defaultMessage: "Epoetin Zeta"
    },
    [ErythropoetinProductActiveIngredient.METHOXY_POLYETHYLENEGLYCOL_EPOETIN_BETA]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.erythropoetinProductActiveIngredient.METHOXY_POLYETHYLENEGLYCOL_EPOETIN_BETA",
        defaultMessage: "Methoxy-polyethyleneglycol-epoetin beta"
    },
    [ErythropoetinProductActiveIngredient.OTHER]: {
        id: "ktx.transplantationScreening.medicalHistory.medicalTreatment.erythropoetinProductActiveIngredient.OTHER",
        defaultMessage: "Egyéb"
    }
};
const drugType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_ACEI)
        .interpretation({ vocab: "ktx", code: "drug_type_acei" })
        .tag({ vocab: "ktx", code: "drug_type" }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_ARB)
        .interpretation({ vocab: "ktx", code: "drug_type_arb" })
        .tag({ vocab: "ktx", code: "drug_type" }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_BETA_RECEPTOR_INHIBITOR)
        .interpretation({
        vocab: "ktx",
        code: "drug_type_beta_receptor inhibitor"
    })
        .tag({ vocab: "ktx", code: "drug_type" }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_DIURETICS)
        .interpretation({ vocab: "ktx", code: "drug_type_diuretics" })
        .tag({ vocab: "ktx", code: "drug_type" }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_AMLODIPINE_DHP)
        .interpretation({ vocab: "ktx", code: "drug_type_amlodipine_dhp" })
        .tag({ vocab: "ktx", code: "drug_type" }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_NON_DHP)
        .interpretation({ vocab: "ktx", code: "drug_type_nonDHP" })
        .tag({ vocab: "ktx", code: "drug_type" }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_AMIODARONE)
        .interpretation({ vocab: "ktx", code: "drug_type_amiodarone" })
        .tag({ vocab: "ktx", code: "drug_type" }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_ACETHYLSALICILATE)
        .interpretation({ vocab: "ktx", code: "drug_type_acethylsalicilate" })
        .tag({ vocab: "ktx", code: "drug_type" }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_CLOPIDOGREL)
        .interpretation({ vocab: "ktx", code: "drug_type_clopidogrel" })
        .tag({ vocab: "ktx", code: "drug_type" }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_OTHER_TAGS_THROMBOCYTE_AGGREGATION_INHIBITORS).interpretation({
        vocab: "ktx",
        code: "drug_type_other_TAGs_thrombocyte_aggregation_inhibitors"
    }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_CALCIUM_CONTAIN_PHOSPPHATE_BINDERS)
        .interpretation({
        vocab: "ktx",
        code: "drug_type_calcium_contain_phospphate_binders"
    })
        .tag({ vocab: "ktx", code: "drug_type" }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_VITAMINE_D_PRODUCT)
        .interpretation({ vocab: "ktx", code: "drug_type_vitamine_D_product" })
        .tag({ vocab: "ktx", code: "drug_type" }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_ERYTHROPOETIN_PRODUCT)
        .interpretation({
        vocab: "ktx",
        code: "drug_type_erythropoetin_product"
    })
        .tag({ vocab: "ktx", code: "drug_type" }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_OAC_NOAC).interpretation({
        vocab: "ktx",
        code: "drug_type_OAC_NOAC"
    }),
    schema_1.Schema.singleChoiceItem(DrugType.DRUG_TYPE_OTHER)
        .interpretation({ vocab: "ktx", code: "drug_type_other" })
        .tag({ vocab: "ktx", code: "drug_type" })
]).transferInterpretationsAndTagsToParent();
const calciumActiveIngredient = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../drugType} === "drug_type_calcium_contain_phospphate_binders"`), schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(CalciumActiveIngredient.CALCICARB),
    schema_1.Schema.multiChoiceItem(CalciumActiveIngredient.CALCETAT),
    schema_1.Schema.multiChoiceItem(CalciumActiveIngredient.PHOSPHODEP),
    schema_1.Schema.multiChoiceItem(CalciumActiveIngredient.RENVELA),
    schema_1.Schema.multiChoiceItem(CalciumActiveIngredient.IRON_CONTAINING_PHOSPHATE_BINDER)
]));
const vitaminDactiveIngredient = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../drugType} === "drug_type_vitamine_D_product"`), schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(VitaminDactiveIngredient.OH_CHOLECALCIFEROL),
    schema_1.Schema.multiChoiceItem(VitaminDactiveIngredient.ALFACALCIDIOL),
    schema_1.Schema.multiChoiceItem(VitaminDactiveIngredient.CALCITRIOL),
    schema_1.Schema.multiChoiceItem(VitaminDactiveIngredient.MIMPARA),
    schema_1.Schema.multiChoiceItem(VitaminDactiveIngredient.ZEMPLAR),
    schema_1.Schema.multiChoiceItem(VitaminDactiveIngredient.OTHER)
]));
const erythropoetinProductActiveIngredient = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../drugType} === "drug_type_erythropoetin_product"`), schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(ErythropoetinProductActiveIngredient.DARBAPOETIN),
    schema_1.Schema.multiChoiceItem(ErythropoetinProductActiveIngredient.EPOETIN_BETA),
    schema_1.Schema.multiChoiceItem(ErythropoetinProductActiveIngredient.ARANESP),
    schema_1.Schema.multiChoiceItem(ErythropoetinProductActiveIngredient.BINOCRIT),
    schema_1.Schema.multiChoiceItem(ErythropoetinProductActiveIngredient.NEO_RECORMON),
    schema_1.Schema.multiChoiceItem(ErythropoetinProductActiveIngredient.EPORATIO),
    schema_1.Schema.multiChoiceItem(ErythropoetinProductActiveIngredient.RETACRIT),
    schema_1.Schema.multiChoiceItem(ErythropoetinProductActiveIngredient.METHOXY_POLYETHYLENEGLYCOL_EPOETIN_BETA),
    schema_1.Schema.multiChoiceItem(ErythropoetinProductActiveIngredient.OTHER)
]));
const drugTypeOther = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../drugType} === "drug_type_other"`), schema_1.Schema.string().maxLength(10000).tag({ vocab: "ktx", code: "drug_type" }));
const vitaminDactiveIngredientTypeOther = schema_1.Schema.ifThen(schema_1.Schema.expression(`Array.isArray({../vitaminDActiveIngredient}) && ({../vitaminDActiveIngredient}).includes("other")`), schema_1.Schema.string()
    .maxLength(10000)
    .tag({ vocab: "ktx", code: "drug_type" })
    .tag({ vocab: "ktx", code: "drug_type_vitamine_D_product" }));
const erythropoetinProductActiveIngredientTypeOther = schema_1.Schema.ifThen(schema_1.Schema.expression(`Array.isArray({../erythropoetinProductActiveIngredient}) && ({../erythropoetinProductActiveIngredient}).includes("other")`), schema_1.Schema.string()
    .maxLength(10000)
    .tag({ vocab: "ktx", code: "drug_type" })
    .tag({ vocab: "ktx", code: "drug_type_erythropoetin_product" }));
const drugTypes = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().default({}).sealed(true).properties({
    drugType,
    calciumActiveIngredient,
    vitaminDActiveIngredient: vitaminDactiveIngredient,
    erythropoetinProductActiveIngredient,
    drugTypeOther,
    vitaminDActiveIngredientTypeOther: vitaminDactiveIngredientTypeOther,
    erythropoetinProductActiveIngredientTypeOther
}));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ drugTypes })
    .interpretation({ vocab: "ktx", code: "medical_treatment_statement" })
    .tag({ vocab: "fyrms", code: "action" });
